import { useClientPortalAPI } from "@certn/api/src/useClientPortalAPI";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function InviteMethodFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { data: links = [], isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/apply-links/options/",
    pathname.includes("/group-overview")
      ? {
          customer_group_id:
            params.customer_group_id && params.customer_group_id.split(","),
        }
      : {}
  );

  if (!links.length) {
    return null;
  }

  return (
    <Picker
      isLoading={isLoading}
      showActionBar
      selectedKeys={params.apply_link_id?.split(",") || []}
      onSelectionChange={(keys) => setParam("apply_link_id", Array.from(keys))}
      label={t("Apply link")}
      items={links}
      selectionMode="multiple"
      testID="invite-method-filter"
    />
  );
}
